import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBasket, Loader2, Store } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

export default function GroceryHub() {
  const [d, setD] = useState(null);
  const [ps, setPs] = useState(null);
  useEffect(() => { api.get("/grocery/directory").then(({ data }) => setD(data)).catch(() => {}); api.get("/grocery/pricesmart").then(({ data }) => setPs(data)).catch(() => {}); }, []);
  if (!d) return <div className="grid place-items-center py-24"><Loader2 className="animate-spin text-emerald" /></div>;
  return (
    <div className="max-w-7xl mx-auto px-4 py-8 space-y-8" data-testid="grocery-hub">
      <header className="rounded-3xl bg-emerald-deep text-white p-8">
        <p className="text-xs uppercase tracking-[0.2em] text-white/60">Groceries & Supermarkets</p>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl mt-1 flex items-center gap-3"><ShoppingBasket /> Jamaican grocery directory</h1>
        <p className="text-sm text-white/80 mt-3 max-w-2xl">{d.note}</p>
        <p className="text-[11px] text-white/60 mt-3">{d.hierarchy.join(" → ")}</p>
      </header>
      {ps && (
        <section className="rounded-3xl border border-border bg-card p-6" data-testid="pricesmart-section">
          <p className="text-xs text-muted-foreground">{ps.path.join(" → ")}</p>
          <h2 className="font-display font-extrabold text-2xl mt-1">PriceSmart</h2>
          <p className="text-sm text-muted-foreground mt-1">{ps.merchant?.parish} · {ps.note}</p>
          <div className="flex flex-wrap gap-1.5 mt-4" data-testid="pricesmart-categories">{ps.categories.map((c) => <span key={c.name} className={`rounded-full px-3 py-1 text-xs ${c.count ? "bg-emerald/10 text-emerald-deep font-semibold" : "bg-secondary text-muted-foreground"}`}>{c.name}{c.count ? ` · ${c.count}` : ""}</span>)}</div>
          {ps.products.length ? <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">{ps.products.map((p) => <ProductCard key={p.id} product={p} />)}</div> : <p className="text-xs text-muted-foreground mt-4" data-testid="pricesmart-empty">No verified PriceSmart listings yet — Founder/Admin imports them via Catalogue import or a supplier feed.</p>}
        </section>
      )}
      {d.groups.map((g) => g.merchants.length > 0 && (
        <section key={g.slug} data-testid={`grocery-group-${g.slug}`}>
          <h2 className="font-semibold text-sm mb-2">{g.name} · {g.merchants.length}</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">{g.merchants.map((m) => (
            <Link key={m.slug} to={`/merchant/${m.slug}`} data-testid={`grocery-merchant-${m.slug}`} className="rounded-2xl border border-border bg-card p-4 hover:border-ink transition-colors">
              <div className="flex items-center gap-2"><Store size={16} className="text-emerald" /><b className="text-sm">{m.name}</b></div>
              <p className="text-[11px] text-muted-foreground mt-1">{m.parish}</p>
              <span className={`inline-block mt-2 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ${m.orderable ? "bg-emerald/10 text-emerald-deep" : "bg-amber-100 text-amber-800"}`} data-testid={`grocery-status-${m.slug}`}>{m.orderable ? `${m.product_count} products` : "Directory listing · availability unknown"}</span>
            </Link>))}</div>
        </section>
      ))}
    </div>
  );
}
